import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchOwnerData from '../Services/fetchOwnerData';

export default function useOwnerProductMasterData() {
	const { accessToken } = useAuth();

	const brandsQuery = useQuery({
		queryKey: ['owner'],
		queryFn: () => fetchOwnerData({ accessToken }),
		staleTime: Infinity,
		retry: false,
	});

	return brandsQuery;
}
